import { useCallback, useState } from "react"

export const useForceUpdater = () => {
  const [ref, setRef] = useState(Symbol("updator"))

  return [ref, useCallback(() => setRef(Symbol("updator")), [])] as const
}
